import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
export default function Login() {
  const { loginWithRedirect } = useAuth0();
  useEffect(() => {
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);
    if (false) {
      (async () => {
        await loginWithRedirect({});
      })();
    } else {
      (async () => {
        await loginWithRedirect();
      })();
    }
  }, []);
  return <></>;
}
